export enum LOAD_SELECT_TELEPHONE_SURVEYS {
	START = 'LOAD_SELECT_TELEPHONE_SURVEYS_START',
	DONE = 'LOAD_SELECT_TELEPHONE_SURVEYS_DONE',
	FAILED = 'LOAD_SELECT_TELEPHONE_SURVEYS_FAILED'
}

export enum LOAD_TELEPHONE_SURVEY {
	START = 'LOAD_TELEPHONE_SURVEY_START',
	DONE = 'LOAD_TELEPHONE_SURVEY_DONE',
	FAILED = 'LOAD_TELEPHONE_SURVEY_FAILED'
}

export enum CREATE_TELEPHONE_SURVEY {
	START = 'CREATE_TELEPHONE_SURVEY_START',
	DONE = 'CREATE_TELEPHONE_SURVEY_DONE',
	FAILED = 'CREATE_TELEPHONE_SURVEY_FAILED'
}
